import { API } from "config/api";
import { API_ROUTES } from "config/apiRoutes";
import { LearnerStrugglingSummary } from "helpers/strugglingLearner";

export type StrugglingLearnerRoster = {
  orgId: string;
  learners: LearnerStrugglingSummary[];
};

export async function fetchStrugglingLearnerRoster(
  orgId: string,
  studentId?: string,
): Promise<StrugglingLearnerRoster> {
  const { data } = await API.get<StrugglingLearnerRoster>(
    API_ROUTES.ORGANIZATIONS.STRUGGLING_LEARNERS(orgId, studentId),
  );
  return {
    orgId: data.orgId,
    learners: data.learners || [],
  };
}

export type RequirementRateComparison = {
  requirementId: string;
  name: string;
  learnerRate: number;
  cohortRate?: number;
  learnerCount: number;
  cohortCount: number;
};

export async function fetchStrugglingLearnerComparison(
  orgId: string,
  studentId: string,
): Promise<RequirementRateComparison[]> {
  const { data } = await API.get<{ requirements: RequirementRateComparison[] }>(
    API_ROUTES.ORGANIZATIONS.STRUGGLING_LEARNER_COMPARISON(orgId, studentId),
  );
  return data.requirements || [];
}
